
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { UserItemProps } from ".";
import { loading, create } from "store/user";

interface ApiUserCreateInputProps extends Omit<UserItemProps, "id"> {
}

type ApiUserCreateOutputProps = OutputBaseProps<{ item: UserItemProps; }, ApiUserCreateInputProps>;

export const apiUserCreate = async (data: ApiUserCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiUserCreateOutputProps>("/api/user/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
    }
    return res;
};